/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CallDealerModal_conversation = {
    readonly currentConversationMember?: {
        readonly phoneCallbackEnabled: boolean | null;
    } | null;
    readonly " $refType": "CallDealerModal_conversation";
};
export type CallDealerModal_conversation$data = CallDealerModal_conversation;
export type CallDealerModal_conversation$key = {
    readonly " $data"?: CallDealerModal_conversation$data;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_conversation">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "CallDealerModal_conversation",
  "type": "Conversation",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "currentConversationMember",
          "name": "currentMember",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "currentUserId",
              "variableName": "userId"
            }
          ],
          "concreteType": "ConversationMember",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "phoneCallbackEnabled",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'a24b3895c8c0adac0f362fcdc7caa9e6';
export default node;
